import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useCheckoutContext } from "@magento/peregrine/lib/context/checkout";
import defaultClasses from "./footerNav.module.scss";
import { useLocation } from "@magento/venia-ui/lib/drivers";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { FooterNavTab } from "./footerNavTab";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import { env } from "build/env";
var FooterNav = () => {
  var {
    formatMessage
  } = useIntl();
  var [{
    tableData
  }] = useCheckoutContext();
  var [{
    footer_nav
  }, {
    setFooterVisible
  }] = useAppContext();
  var [{
    isSignedIn
  }] = useUserContext();
  var {
    isMobile
  } = useWindowSize();
  var location = useLocation();
  var {
    store_view_code
  } = env;
  var homeLocation = formatMessage({
    id: "url.key.home"
  });
  var appHomeLocation = formatMessage({
    id: "url.key.app.home"
  });
  var loyaltyLocation = formatMessage({
    id: "url.key.login"
  });
  var preLoginLocation = formatMessage({
    id: "url.key.pre.login"
  });
  var appLoginLocation = formatMessage({
    id: "url.key.app.login"
  });
  var myAreaLocation = formatMessage({
    id: "url.key.myaccount"
  });
  var orderLocation = formatMessage({
    id: "url.key.order"
  });
  var payLocation = formatMessage({
    id: "url.key.pay"
  });
  var bookLocation = formatMessage({
    id: "url.key.book.a.table"
  });
  var bookingDataLocation = formatMessage({
    id: "url.key.book.a.table.reservation"
  });
  var bookEventLocation = formatMessage({
    id: "url.key.book.event"
  });
  var bookEditLocation = formatMessage({
    id: "url.key.book.a.table.edit"
  });
  var menuLocation = "/?cps=".concat(tableData.cps, "&cpt=").concat(tableData.cpt, "&sales_type=").concat(tableData.sales_type);
  var checkoutLocation = formatMessage({
    id: "url.key.checkout"
  });
  var signupLocation = formatMessage({
    id: "url.key.signup"
  });
  var userDataLocation = formatMessage({
    id: "url.key.loyalty.data"
  });
  var receiptLocation = "/receipt";
  var eventsLocation = formatMessage({
    id: "url.key.events"
  });
  var eventsDetailsLocation = formatMessage({
    id: "url.key.events.details"
  });
  var pswRecoveryLocation = formatMessage({
    id: "url.key.psw.recovery"
  });
  var kioskLoginLocation = formatMessage({
    id: "url.key.kiosk.login"
  });
  var appHomeLocationActive = location.pathname.includes(appHomeLocation);
  var myAreaLocationActive = location.pathname.includes(myAreaLocation);
  var orderLocationActive = location.pathname.includes(orderLocation);
  var payLocationActive = location.pathname.includes(payLocation);
  var bookLocationActive = location.pathname.includes(bookLocation);
  var eventsLocationActive = location.pathname.includes(eventsLocation);
  var hideExtendedPaths = [orderLocation, bookLocation, loyaltyLocation, preLoginLocation, eventsDetailsLocation, bookEventLocation, kioskLoginLocation];
  var hidePaths = [homeLocation, appLoginLocation, checkoutLocation, pswRecoveryLocation, signupLocation, userDataLocation, receiptLocation, bookEditLocation, "/", ...hideExtendedPaths];
  var showPaths = [bookingDataLocation];
  var goToLoyalty = isSignedIn ? null : () => {
    UIkit.offcanvas("#offcanvas-login-dx").show();
  };
  useEffect(() => {
    var hideFooter = (hidePaths.includes(location.pathname) || hideExtendedPaths.some(path => location.pathname.includes(path))) && !showPaths.some(path => location.pathname.includes(path));
    setFooterVisible(!hideFooter);
  }, [location.pathname]);
  return isMobile && footer_nav !== null && footer_nav !== void 0 && footer_nav.visible ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "calc(env(safe-area-inset-bottom, 0) * 0.7 + 0.3em) "
    },
    className: "uk-box-shadow-medium uk-position-relative uk-flex uk-flex-between uk-flex-bottom uk-child-width-1-5 uk-position-fixed uk-position-bottom   ".concat(defaultClasses.root)
  }, /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-home",
    isMain: false,
    targetLocation: appHomeLocation,
    isLocationActive: appHomeLocationActive,
    icon: "home_outline",
    text: formatMessage({
      id: "footer.nav.tab.home"
    })
  }), /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-loyalty",
    isMain: false,
    targetLocation: myAreaLocation,
    isLocationActive: myAreaLocationActive,
    override: goToLoyalty,
    icon: "person",
    text: formatMessage({
      id: "footer.nav.tab.loyalty"
    })
  }), /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-order",
    tableData: tableData,
    isMain: true,
    targetLocation: payLocationActive ? menuLocation : orderLocation,
    isLocationActive: orderLocationActive,
    animationActive: payLocationActive,
    icon: "fork-test",
    text: tableData.cpt && tableData.cps && !payLocationActive ? formatMessage({
      id: "TavoloNumber"
    }) + (tableData.tableDescription || tableData.table) : tableData.cpt && tableData.cps ? formatMessage({
      id: "footer.nav.tab.menu"
    }) : formatMessage({
      id: "footer.nav.tab.order"
    })
  }), store_view_code !== "miscusi_ch_sv" ? /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-book",
    isMain: false,
    targetLocation: bookLocation,
    isLocationActive: bookLocationActive,
    icon: "calendar",
    text: formatMessage({
      id: "footer.nav.tab.booking"
    })
  }) : null, store_view_code !== "miscusi_ch_sv" ? /*#__PURE__*/React.createElement(FooterNavTab, {
    id: "footer-nav-event",
    isMain: false,
    targetLocation: eventsLocation,
    isLocationActive: eventsLocationActive,
    icon: "people",
    text: formatMessage({
      id: "footer.nav.tab.event"
    })
  }) : null) : null;
};
export default FooterNav;